export default "__VITE_ASSET__c06d4895__"